import {
    USER_SHOULD_VERIFY_ID_CARD,
    USER_SHOULD_VERIFY_SMS,
} from '@core/constants';
import User from '@models/user/User';
import { isIdCardVerificationPending } from '@models/user/UserDataService';
import { NotificationType } from '@models/user/enums';
import UserNotification from '@models/user/notifications/UserNotification';

export function addIdCard(user: User, notifications: UserNotification[]) {
    if (!user.isVerifiedIdCard && !isIdCardVerificationPending(user)) {
        notifications.push({
            title: USER_SHOULD_VERIFY_ID_CARD,
            type: NotificationType.idCard,
        });
    }
}

export function addSms(user: User, notifications: UserNotification[]) {
    if (user.shouldVerifySms) {
        notifications.push({
            title: USER_SHOULD_VERIFY_SMS,
            type: NotificationType.sms,
        });
    }
}
